const extendShareTimeline = () => {
    const getQuery = (url, name) => {
        const reg = new RegExp('[^?&]?' + encodeURIComponent(name) + '=[^&]+')
        const arr = url.match(reg)
        if (arr != null) {
            return decodeURIComponent(arr[0].substring(arr[0].search('=') + 1))
        }
        return ''
    }
    const getOptFromShareApp = (options) => {
        const { title, path, imageUrl, timelineImage } = options
        const index = path.indexOf('?') + 1
        let query_str = path.substring(index).replace(/share_by=(\w+_)*/, 'share_by=timeline_')
        let query
        const sub_page = getQuery(query_str, 'sub_page')
        console.error('sub_page', sub_page, sub_page.substring(sub_page.indexOf('?') + 1))
        if (sub_page) {
            query = `share_by=${getQuery(query_str, 'share_by')}`
            query += `&share_by_consultant_uid=${getQuery(query_str, 'share_by_consultant_uid')}`
            if (sub_page.indexOf('?') > -1) {
                query += '&' + sub_page.substring(sub_page.indexOf('?') + 1)
            }
        } else {
            query = query_str
        }
        console.error(query)
        return {
            title,
            query,
            imageUrl: timelineImage || imageUrl
        }
    }
    const wrapPage = (page) => {
        return (obj) => {
            if (!obj['onShareTimeline'] && obj['onShareAppMessage']) {
                obj['onShareTimeline'] = function () {
                    return getOptFromShareApp(obj['onShareAppMessage'].apply(this))
                }
            }
            page(obj)
        }
    }
    const wrapComponent = (component) => {
        return (obj) => {
            if (obj.methods && !obj.methods['onShareTimeline'] && obj.methods['onShareAppMessage']) {
                obj.methods['onShareTimeline'] = function () {
                    return getOptFromShareApp(obj.methods['onShareAppMessage'].apply(this))
                }
            }
            component(obj)
        }
    }
    Page = wrapPage(Page)
    Component = wrapComponent(Component)
}

module.exports = extendShareTimeline
